import type { FunctionComponent } from 'react';
import { BreadCrumbsBar } from '../../../components/BreadCrumbs/BreadCrumbs';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';

export const SuburbPageBreadCrumbsWithData: FunctionComponent = () => {
  const breadcrumbs = useSuburbPageQuery()?.data?.suburbPageBySlug?.breadCrumbs;
  if (!breadcrumbs) return null;

  return <BreadCrumbsBar crumbs={breadcrumbs} />;
};
